import React from "react";
import {
  Card,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Switch,
  TextField,
  Grid,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
// import "flatpickr/dist/flatpickr.css";
import { postMetaDataHash } from "services/apiService";
import { mintNFT } from "services/contractService";
import { changePriceNft } from "services/contractService";
import { postMint } from "services/apiService";
import { mintNFTMarketPlace } from "services/contractService";

import dialogBgImage from "assets/images/dialogBgImage.png";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import CircularProgress from "@mui/material/CircularProgress";
import { useMediaQuery } from "react-responsive";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import DataSaverOffIcon from "@mui/icons-material/DataSaverOff";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { SiBinance } from "react-icons/si";
import colors from "assets/theme-dark/base/colors";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { web3Instance } from "Store/slices/walletSlice";
import { useSelector } from "react-redux";

let currentDate = new Date();
currentDate = `${currentDate.getFullYear()}/${
  currentDate.getMonth() + 1 <= 9
    ? "0" + (currentDate.getMonth() + 1)
    : currentDate.getMonth() + 1
}/${
  currentDate.getDate() <= 9
    ? "0" + currentDate.getDate()
    : currentDate.getDate()
}`;

function MintDialog({ openStatus, onClose, mintData, priceChange }) {
  const web3 = web3Instance();
  let navigate = useNavigate();

  const {
    isWeb3Enabled,
    address,
    chainId,
    balance,
    reward,
    isWalletLoading,
    isRewardLoading,
  } = useSelector((state) => state.walletData);

  const { singh, singhGrey, white, black } = colors;

  const [duration, setDuration] = useState(0);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [royalties, setRoyalties] = useState("");
  const [price, setPrice] = useState(null);
  const [blockChain, setBlockChain] = useState("Binance");
  const [tokenId, setTokenId] = useState(null);
  const [auctionId, setAuctionId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [loading, setLoading] = useState(false);

  const [toggleNft, setToggleNft] = useState(false);
  const [sellingStatus, setSellingStatus] = useState("Not for sale");
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [errorMsg, setErrorMsg] = useState({
    name: { errorMsg: "" },
    description: { errorMsg: "" },
    royalties: { errorMsg: "" },
    price: { errorMsg: "" },
  });

  // console.log("toggleNft", toggleNft);
  // console.log("sellingStats", sellingStatus);

  const dateConverter = (time) => {
    let date = new Date(time);
    // let convertedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    let convertedDate = `${date.getFullYear()}/${date.getMonth() + 1}/${
      date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()
    }`;

    return convertedDate;
  };

  const [marketPlaceTypes, setMarketPlaceTypes] = useState([
    {
      name: "Fixed price",
      value: "For sale",
      icon: <LocalOfferIcon />,
      selected: true,
    },
    {
      name: "Open for bids",
      value: "Open for bidding",
      icon: <DataSaverOffIcon />,
      selected: false,
    },
    {
      name: "Timed auction",
      value: "Time Auction",
      icon: <AccessTimeIcon />,
      selected: false,
    },
  ]);

  useEffect(() => {
    checkNFT();
  }, []);

  const checkNFT = () => {
    if (mintData.postDetails) {
      setName(mintData.name);
      setDescription(mintData.description);
      setRoyalties(mintData.royalties);
      setTokenId(mintData.tokenID);
      setAuctionId(mintData._id);
      // setPrice(mintData.price);
      setToggleNft(true);
      setSellingStatus("For sale");
    }
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.mintPostValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleInputChange = (name, value) => {
    if (name === "name") {
      setName(value);
    } else if (name === "description") {
      setDescription(value);
    } else if (name === "royalties") {
      setRoyalties(value);
    } else if (name === "price") {
      // console.log("priceV", value);
      setPrice(value);
    } else if (name === "startDate") {
      // console.log("SDate", value);
      setStartDate(value);
    } else if (name === "endDate") {
      // console.log("EDate", value);
      setEndDate(value);
    }
  };

  const handleNftSwitch = (e) => {
    // console.log(e.target.checked);
    setToggleNft(e.target.checked);
    // if (mintData.postDetails) {
    //   setToggleNft(true);
    //   setSellingStatus("For sale");
    //   setPrice(1);
    // } else {
    if (e.target.checked === false) {
      setSellingStatus("Not for sale");
      setPrice(null);
      //  console.log("Not FOR SALE");
    } else if (e.target.checked === true) {
      setSellingStatus("For sale");
      setPrice("");
      //  console.log("FOR SALE");
    }
    // }
  };

  const handleNftTypes = (name, value) => {
    setMarketPlaceTypes(
      marketPlaceTypes.map((item) => {
        if (item.name === name) {
          return {
            ...item,
            selected: true,
          };
        }
        return {
          ...item,
          selected: false,
        };
      })
    );

    if (name === "Fixed price") {
      setSellingStatus(value);
      setStartDate(null);
      setEndDate(null);
      //  console.log("value", value);
    } else if (name === "Open for bids") {
      setSellingStatus(value);
      setPrice(0);
      setStartDate(null);
      setEndDate(null);
      //  console.log("value", value);
    } else if (name === "Timed auction") {
      setSellingStatus(value);
      setStartDate(currentDate);
      setEndDate(currentDate);
      // console.log("value", value);
    }
  };

  // console.log("mintData", mintData);

  const handleMint = async () => {
    // e.preventDefault();

    let errorLengthName = customValidations("name", name);
    let errorLengthDescription = customValidations("description", description);
    let errorLengthRoyalties = customValidations("royalties", royalties);

    if (
      errorLengthName === 1 ||
      errorLengthDescription === 1 ||
      errorLengthRoyalties === 1
    ) {
      return;
    }

    if (toggleNft && sellingStatus !== "Open for bidding") {
      let errorLengthPrice = customValidations("price", price);
      if (errorLengthPrice === 1) {
        return;
      }
    }

    setLoading(true);
    // console.log("name", name);
    // console.log("description", description);
    // console.log("royalties", royalties);
    // console.log("price", price);
    // console.log("postId", mintData._id);
    // console.log("sellingStatus", sellingStatus);
    // console.log("AucId", auctionId);

    // if (startDate === null) {
    //   console.log("st", startDate);
    // } else {
    //   console.log("DC", dateConverter(startDate));
    //   // console.log("DC", startDate);
    //   dateConverter(startDate);
    // }
    // if (endDate === null) {
    //   console.log("Ed", endDate);
    // } else {
    //   console.log("DC", dateConverter(endDate));
    //   // console.log("DC", endDate);
    //   dateConverter(endDate);
    // }

    let mintNft = {};
    let getPostMetaDataHash = {};

    if (
      mintData.nftStatus === "false" ||
      mintData.postDetails.nftStatus === "false"
    ) {
      const postData = {
        postID: mintData._id,
        name: name,
        description: description,
        royalties: royalties,
      };

      // console.log("data", postData);

      getPostMetaDataHash = await postMetaDataHash(postData);
      // console.log("postMetaHash", getPostMetaDataHash);
      mintNft = await mintNFT(
        web3,
        address,
        royalties,
        getPostMetaDataHash.metadataURI
      );

      // console.log("mintNFT", mintNft);

      // if (!toggleNft && mintNft.transactionHash) {
      //   // Swal.fire("Post minted successfully", "", "success");

      //   toast.success(`Post minted successfully`, {
      //     style: {
      //       fontSize: "12px",
      //     },
      //   });

      //   setLoading(false);
      //   onClose();

      // }
    }

    if (mintNft.transactionHash || mintData.mintTransactionHash) {
      if (priceChange) {
        const changePriceNftRes = await changePriceNft(
          web3,
          address,
          tokenId,
          price
        );
        // console.log("changePriceRes", changePriceNftRes);
        if (changePriceNftRes.transactionHash) {
          const mintedDataStatusChange = {
            postID: mintData._id,
            name: name,
            description: description,
            royalties: royalties,
            transactionHash: mintData.mintTransactionHash,
            sellingStatus: sellingStatus,
            price: price,
            auctionID: mintData._id,
            postMetaDataHash: getPostMetaDataHash.metadataURI
              ? getPostMetaDataHash.metadataURI
              : mintData.postMetaDataHash,
            startDateTimeAuction: startDate,
            endDateTimeAuction: endDate,
          };

          const postMintRes2 = await postMint(mintedDataStatusChange);
          // console.log("postMintRes2", postMintRes2);

          if (postMintRes2.status === 200) {
            onClose();
            toast.success(`Price changed`, {
              style: {
                fontSize: "12px",
              },
            });
            setLoading(false);
            navigate(`/profile/?username=${localStorage.userNameSingh}`);
            return;
          } else {
            toast.error(`Something went wrong, Please try again later`, {
              style: {
                fontSize: "12px",
              },
            });
            setLoading(false);
            return;
          }
        } else {
          toast.error(`User rejected the transaction`, {
            style: {
              fontSize: "12px",
            },
          });
          setLoading(false);
          return;
        }
      }

      let postMintRes = {};

      if (!mintData.postDetails) {
        const mintedDataForTokenId = {
          postID: mintData.postDetails
            ? mintData.postDetails._id
            : mintData._id,
          name: name,
          description: description,
          royalties: royalties,
          transactionHash: mintNft.transactionHash
            ? mintNft.transactionHash
            : mintData.mintTransactionHash,
          sellingStatus: "Not for sale",
          price: null,
          auctionID: null,
          postMetaDataHash: getPostMetaDataHash.metadataURI
            ? getPostMetaDataHash.metadataURI
            : mintData.postMetaDataHash,
          startDateTimeAuction: null,
          endDateTimeAuction: null,
        };

        postMintRes = await postMint(mintedDataForTokenId);
        // console.log("postMintRes", postMintRes);

        if (!toggleNft && postMintRes.data.tokenID) {
          toast.success(`Post minted successfully`, {
            style: {
              fontSize: "12px",
            },
          });

          setLoading(false);
          onClose();
          navigate(`/nft-marketplace/?status=Not for sale`);
          return;
        }
        //  else {
        //   toast.error(`Something went wrong, Please try again later`, {
        //     style: {
        //       fontSize: "12px",
        //     },
        //   });

        //   setLoading(false);
        //   return;
        // }
      }

      // console.log("price", price);

      if (!priceChange && toggleNft === true) {
        const mintNftMarketPlace = await mintNFTMarketPlace(
          web3,
          address,
          postMintRes.data ? postMintRes.data.tokenID : mintData.tokenID,
          price,
          sellingStatus
        );
        // console.log(mintNftMarketPlace);
        // console.log("PostmintRes", postMintRes);
        // onClose();
        // Swal.fire("Post minted and placed on marketplace", "", "success");

        if (mintNftMarketPlace.transactionHash) {
          // console.log("STARTDATE", dateConverter(startDate));
          // console.log("ENDDATE", dateConverter(endDate));
          // console.log("onMarketPlace");
          // console.log("PostmintRes", postMintRes);
          const mintedDataStatusChange = {
            postID: mintData.postDetails
              ? mintData.postDetails._id
              : mintData._id,
            name: name,
            description: description,
            royalties: royalties,
            transactionHash: mintNft.transactionHash
              ? mintNft.transactionHash
              : mintData.mintTransactionHash,
            sellingStatus: sellingStatus,
            price: price,
            auctionID: postMintRes.data
              ? postMintRes.data.AuctionID
              : mintData._id,
            postMetaDataHash: getPostMetaDataHash.metadataURI
              ? getPostMetaDataHash.metadataURI
              : mintData.postMetaDataHash,
            startDateTimeAuction: dateConverter(startDate),
            endDateTimeAuction: dateConverter(endDate),
          };

          const postMintRes2 = await postMint(mintedDataStatusChange);
          // console.log("postMintRes2", postMintRes2);

          if (postMintRes2.status === 200) {
            toast.success(`Nft placed on marketplace`, {
              style: {
                fontSize: "12px",
              },
            });
            setLoading(false);
            onClose();
            navigate(`/nft-marketplace/?status=${sellingStatus}`);
          } else {
            toast.error(`Something went wrong, Please try again later`, {
              style: {
                fontSize: "12px",
              },
            });
            setLoading(false);
            return;
          }
        } else {
          toast.error(`Contract failed, please try again later`, {
            style: {
              fontSize: "12px",
            },
          });
          setLoading(false);
          onClose();
          return;
        }
      }
    } else {
      onClose();
      // Swal.fire("Contract failed", "", "error");
      // console.log("contract initialize failed");
      toast.error(`Contract failed, please try again`, {
        style: {
          fontSize: "12px",
        },
      });
      setLoading(false);
      return;
    }
  };

  return (
    <Dialog
      open={openStatus}
      maxWidth="lg"
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        sx={{
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        {/* <form onSubmit={handleMint}> */}
        <DialogTitle>
          <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
            {isTabletOrMobile && (
              <IconButton
              // onClick={() => handleBack()}
              >
                <IconButton onClick={onClose} color="white" fontSize="30px">
                  <ArrowBackIcon />
                </IconButton>
              </IconButton>
            )}

            <MDBox>
              <MDTypography
                fontWeight="bold"
                color="singh"
                sx={{
                  fontSize: isTabletOrMobile ? "20px" : "40px",
                  marginRight: isTabletOrMobile && "120px",
                  marginTop: isTabletOrMobile && "15px",
                }}
              >
                Mint NFT
              </MDTypography>
            </MDBox>

            {isDesktopOrLaptop && (
              <MDBox sx={{ display: "flex", alignItems: "center" }}>
                <MDTypography fontWeight="bold" fontSize="30px">
                  {localStorage.userNameSingh}
                </MDTypography>
                <MDAvatar />
              </MDBox>
            )}
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{}}>
            <Grid
              item
              container
              xs={12}
              md={6}
              sx={{ justifyContent: "center" }}
            >
              <MDBox
                sx={{
                  height: isTabletOrMobile ? "270px" : "100%",
                  width: isTabletOrMobile ? "270px" : "500px",
                  marginRight: isDesktopOrLaptop && "8px",
                  border: "2px dashed #6a6a6a",
                  cursor: "pointer",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#000",
                  },
                }}
              >
                <img
                  style={{ borderRadius: "12px" }}
                  src={mintData.photo || mintData.postDetails.photo}
                  height="100%"
                  width="100%"
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} sx={{ padding: "10px" }}>
              <MDBox>
                <MDBox sx={{ marginBottom: "20px" }}>
                  <TextField
                    disabled={priceChange || mintData.postDetails}
                    fullWidth
                    // inputProps={{ style: { color: "#fff" } }}
                    variant="outlined"
                    name="name"
                    label="Name"
                    placeholder="eg:Mark Johnson"
                    value={name}
                    error={errorMsg.name.errorMsg.length > 0}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    helperText={errorMsg.name.errorMsg}
                  />
                </MDBox>
                <MDBox sx={{ marginBottom: "10px" }}>
                  <TextField
                    disabled={priceChange || mintData.postDetails}
                    fullWidth
                    placeholder="eg:more info about this NFT"
                    name="description"
                    label="Description"
                    multiline
                    rows={6}
                    value={description}
                    error={errorMsg.description.errorMsg.length > 0}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    helperText={errorMsg.description.errorMsg}
                  />
                </MDBox>
                <MDBox sx={{ marginBottom: "20px" }}>
                  <TextField
                    sx={{
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                        {
                          "-webkit-appearance": "none",
                        },
                    }}
                    disabled={priceChange || mintData.postDetails}
                    fullWidth
                    type="number"
                    name="royalties"
                    label="Royalties"
                    placeholder="eg:10"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* <SiBinance
                              style={{
                                color: `${singh.main}`,
                                fontSize: "20px",
                              }}
                            /> */}
                          <MDTypography>%</MDTypography>
                        </InputAdornment>
                      ),
                    }}
                    value={royalties}
                    error={errorMsg.royalties.errorMsg.length > 0}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (e.key === ".") {
                        e.preventDefault();
                      }
                    }}
                    helperText={errorMsg.royalties.errorMsg}
                  />
                </MDBox>
                <MDBox sx={{ marginBottom: "20px" }}>
                  {/* <MDTypography fontSize="20px">Blockchain</MDTypography> */}
                  <TextField
                    disabled
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SiBinance
                            style={{
                              color: `${singh.main}`,
                              fontSize: "20px",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    label="Blockchain"
                    name="Blockchain"
                    placeholder="Binance"
                    value={blockChain}
                  />
                </MDBox>

                <MDBox sx={{ marginBottom: "20px" }}>
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <MDTypography fontWeight="bold" fontSize="18px">
                      Put on marketplace
                    </MDTypography>
                    <Switch
                      disabled={mintData.postDetails || loading}
                      checked={toggleNft}
                      onChange={(e) => handleNftSwitch(e)}
                    />
                  </MDBox>

                  <MDTypography fontSize="13px">
                    Put your new NFT on Singh Coin marketplace
                  </MDTypography>
                </MDBox>
                {toggleNft && (
                  <MDBox
                    sx={{
                      display: "flex",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {marketPlaceTypes.map((item, idx) => (
                      <MDBox
                        disabled={priceChange}
                        key={idx}
                        sx={{
                          border: "1px solid #F2CB2E",
                          borderRadius: "10px",
                          height: "130px",
                          width: "135px",
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: item.selected
                            ? `${singh.main}`
                            : "transparent",
                        }}
                        onClick={
                          priceChange
                            ? null
                            : () => handleNftTypes(item.name, item.value)
                        }
                      >
                        <MDBox sx={{}}>
                          <IconButton color="white">{item.icon}</IconButton>
                          {/* {item.icon} */}
                          <MDTypography
                            fontWeight="bold"
                            sx={{
                              fontSize: isTabletOrMobile ? "15px" : "15px",
                            }}
                          >
                            {item.name}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ))}
                  </MDBox>
                )}

                {sellingStatus === "For sale" ? (
                  <MDBox sx={{ marginBottom: "20px" }}>
                    {/* <MDTypography fontSize="20px">Price</MDTypography> */}
                    <TextField
                      sx={{
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            "-webkit-appearance": "none",
                          },
                      }}
                      autoComplete="off"
                      type="number"
                      fullWidth
                      placeholder="eg:5"
                      name="price"
                      label="price"
                      value={price}
                      error={errorMsg.price.errorMsg.length > 0}
                      onChange={(e) =>
                        handleInputChange(e.target.name, e.target.value)
                      }
                      helperText={errorMsg.price.errorMsg}
                    />
                  </MDBox>
                ) : sellingStatus === "Time Auction" ? (
                  <MDBox>
                    <MDBox>
                      {/* <MDTypography fontSize="20px">Minimum bid</MDTypography> */}
                      <TextField
                        sx={{
                          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              "-webkit-appearance": "none",
                            },
                        }}
                        fullWidth
                        type="number"
                        placeholder="eg:2"
                        name="price"
                        label="Minimum bid"
                        value={price}
                        error={errorMsg.price.errorMsg.length > 0}
                        onChange={(e) =>
                          handleInputChange(e.target.name, e.target.value)
                        }
                        helperText={errorMsg.price.errorMsg}
                      />
                    </MDBox>
                    <MDBox sx={{ display: "flex", gap: "10px" }}>
                      <MDBox
                        sx={{
                          width: "50%",
                          "& .form-control": {
                            backgroundColor: `${black.main}`,
                            color: `${white.main}`,
                            border: `1px solid ${singhGrey.main}`,
                            boxShadow: "none",
                          },
                          "& :hover": {
                            borderColor: `${singh.main}`,
                          },
                        }}
                      >
                        <MDTypography
                          fontSize="15px"
                          fontFamily="Roboto"
                          color="text"
                        >
                          Start date
                        </MDTypography>
                        {/* <TextField fullWidth placeholder="eg:2" /> */}
                        <Flatpickr
                          options={{
                            backgroundColor: "red",
                            altInput: true,
                            altFormat: "Y/m/d",
                            // dateFormat: "Y/m/d",
                            minDate: currentDate,
                          }}
                          value={startDate}
                          onChange={(e) => handleInputChange("startDate", e[0])}
                        />
                      </MDBox>
                      <MDBox
                        sx={{
                          width: "50%",
                          "& .form-control": {
                            backgroundColor: `${black.main}`,
                            color: `${white.main}`,
                            border: `1px solid ${singhGrey.main}`,
                            boxShadow: "none",
                          },
                          "& :hover": {
                            borderColor: `${singh.main}`,
                          },
                        }}
                      >
                        <MDTypography
                          fontSize="15px"
                          fontFamily="Roboto"
                          color="text"
                        >
                          End date
                        </MDTypography>

                        <Flatpickr
                          options={{
                            altInput: true,
                            altFormat: "Y/m/d",
                            minDate: currentDate,
                          }}
                          value={endDate}
                          onChange={(e) => handleInputChange("endDate", e[0])}
                        />
                      </MDBox>
                    </MDBox>
                  </MDBox>
                ) : null}
              </MDBox>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MDButton
            disabled={loading}
            type="submit"
            color="singh"
            sx={{ minWidth: isTabletOrMobile ? "100%" : "180px" }}
          >
            <MDTypography
              fontWeight="bold"
              fontSize="25px"
              onClick={() => handleMint()}
            >
              {loading ? (
                <CircularProgress size={30} color="inherit" />
              ) : mintData.postDetails ? (
                priceChange ? (
                  "Change Price"
                ) : (
                  "Set for sale"
                )
              ) : (
                "Mint"
              )}
            </MDTypography>
          </MDButton>
        </DialogActions>
        {/* </form> */}
      </MDBox>
    </Dialog>
  );
}

export default MintDialog;
